/**
 * Created by Alex Aguilar on 5/24/2016.
 */
(function(){
    'use strict';

    angular.module('aacAutoComplete', [])
        .directive('autocompleteSegment', ['$rootScope', 'stretchAssistantService', autoCompleteSegment]);

    function autoCompleteSegment($rootScope, stretchAssistantService){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        }
        return directive;

        function linkFunc(scope, element, attrs){
            var stretchAssistants = [],
                responseStretchAssistants = [];

            element.autocomplete({
                minLength: 1,
                delay: 500,
                source: function(request, response){

                    var search = request.term;

                    if(search != ""){
                        stretchAssistantService.search(search)
                            .then(function(res){
                                responseStretchAssistants = res.data.stretchAssistants;
                                stretchAssistants = dataAutoComplete(responseStretchAssistants);
                                response(stretchAssistants);
                            });
                    }
                },
                focus: function(){

                },
                select: function(event, ui){
                    var posValue = stretchAssistants.indexOf(ui.item.value),
                        objectStretchAssistant = responseStretchAssistants[posValue];
                    $rootScope.segmentAssistantTmp = objectStretchAssistant;
                },
                change: function(){

                }
            });

            function dataAutoComplete(stretchAssistants){
                var res = [];
                angular.forEach(stretchAssistants, function(stretchAssistant){
                    var dataName = stretchAssistant.originAirport.locality.region.initials +
                        "(" + stretchAssistant.originAirport.initials + ")" + " - " +
                        stretchAssistant.destinyAirport.locality.region.initials +
                        "(" + stretchAssistant.destinyAirport.initials + ")";
                    res.push(dataName)
                });
                return res;
            }
        }
    }

})();
